import PropTypes from 'prop-types';
import { useMemo, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import FilterOfferByVenue from 'components/Category/FilterOffersByVenue';
import CategoryNav from 'components/Category/Nav';
import Sidebar from 'components/Sidebar';
import SidebarGoogleAd from 'components/Sidebar/GoogleAd';

import { noop } from 'lib/utils';

const CategorySidebar = ({
  categoryName,
  className,
  gaEventCategory,
  isGoogleAdActive = false,
  offersFilters,
  subcategories,
  onOffersVenueFilterChange = noop,
  onNavItemClick = noop,
  ...rest
}) => {
  const navRef = useRef(null);
  const filterOfferByVenueRef = useRef(null);
  const sidebarGoogleAdRef = useRef(null);

  const refsToBeIgnoredBeforeFixing = useMemo(() => {
    const refs = [navRef, filterOfferByVenueRef];

    if (isGoogleAdActive) {
      refs.push(sidebarGoogleAdRef);
    }

    return refs;
  }, [isGoogleAdActive]);

  return (
    <Sidebar
      className={twMerge('mb-8 gap-y-4', className)}
      refsToBeIgnoredBeforeFixing={refsToBeIgnoredBeforeFixing}
      {...rest}
    >
      <CategoryNav
        ref={navRef}
        categoryName={categoryName}
        subcategories={subcategories}
        onNavItemClick={onNavItemClick}
      />
      <FilterOfferByVenue
        ref={filterOfferByVenueRef}
        className="hidden xl:flex"
        gaEventCategory={gaEventCategory}
        venue={offersFilters.venue}
        onOffersVenueFilterChange={onOffersVenueFilterChange}
      />
      {isGoogleAdActive && (
        <SidebarGoogleAd
          ref={sidebarGoogleAdRef}
          adId="offer_category_page_sidebar_1_300x250"
          adPath="/promobit.com.br_offer_category_page/sidebar_1_300x250"
        />
      )}
    </Sidebar>
  );
};

CategorySidebar.propTypes = {
  categoryName: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  offersFilters: PropTypes.shape().isRequired,
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      subcategoryId: PropTypes.number.isRequired,
      subcategoryName: PropTypes.string.isRequired,
      subcategorySlug: PropTypes.string.isRequired,
    })
  ).isRequired,
  isGoogleAdActive: PropTypes.bool,
  onOffersVenueFilterChange: PropTypes.func,
  onNavItemClick: PropTypes.func,
};

export default CategorySidebar;
